import {
  INIT_REVISIONS,
  LOAD_REVISION_DATA,
  LOAD_REVISION_DATA_SUCCESS,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  UPDATE_OLDEST_REVISION,
  UPDATE_LATEST_REVISION,
  UPDATE_ORIGINAL_REVISION,
  UPDATE_MODIFIED_REVISION,
  POST_PROJECT_REVISION,
  POST_PROJECT_REVISION_START,
  POST_PROJECT_REVISION_SUCCESS,
  POST_PROJECT_REVISION_ERROR,
  FETCH_PROJECT_REVISIONS,
  FETCH_PROJECT_REVISIONS_START,
  FETCH_PROJECT_REVISIONS_SUCCESS,
  FETCH_PROJECT_REVISIONS_ERROR,
  FETCH_REVISION_DATA,
  FETCH_REVISION_DATA_START,
  FETCH_REVISION_DATA_SUCCESS,
  FETCH_REVISION_DATA_ERROR,
} from './constants'
import {
  buildAsyncAction
} from 'containers/Async/actions'

const initRevisions = () => ({ type: INIT_REVISIONS })
const loadRevisionData = (projectId, revisionId) => ({ type: LOAD_REVISION_DATA, projectId, revisionId })
const loadRevisionDataSuccess = (elements) => ({ type: LOAD_REVISION_DATA_SUCCESS, elements })
const updateRevisions = (revisionId, elements) => ({ type: UPDATE_REVISIONS, revisionId, elements })
const updateCurrentRevision = (revisionId) => ({ type: UPDATE_CURRENT_REVISION, revisionId })
const updateOldestRevision = (revisionId) => ({ type: UPDATE_OLDEST_REVISION, revisionId })
const updateLatestRevision = (revisionId) => ({ type: UPDATE_LATEST_REVISION, revisionId })
const updateOriginalRevision = (revisionId) => ({ type: UPDATE_ORIGINAL_REVISION, revisionId })
const updateModifiedRevision = (revisionId) => ({ type: UPDATE_MODIFIED_REVISION, revisionId })

const startPostProjectRevision = buildAsyncAction(
  POST_PROJECT_REVISION,
  POST_PROJECT_REVISION_SUCCESS,
  [POST_PROJECT_REVISION_START, POST_PROJECT_REVISION_ERROR]
)
const postProjectRevision = (projectId, params) => ({ type: POST_PROJECT_REVISION, projectId, params })
const postProjectRevisionStart = () => ({ type: POST_PROJECT_REVISION_START })
const postProjectRevisionSuccess = () => ({ type: POST_PROJECT_REVISION_SUCCESS })
const postProjectRevisionError = (error) => ({ type: POST_PROJECT_REVISION_ERROR, error })
const fetchProjectRevisions = (projectId) => ({ type: FETCH_PROJECT_REVISIONS, projectId })
const fetchProjectRevisionsStart = () => ({ type: FETCH_PROJECT_REVISIONS_START })
const fetchProjectRevisionsSuccess = () => ({ type: FETCH_PROJECT_REVISIONS_SUCCESS })
const fetchProjectRevisionsError = (error) => ({ type: FETCH_PROJECT_REVISIONS_ERROR, error })
const startFetchProjectRevisions = buildAsyncAction(
  FETCH_PROJECT_REVISIONS,
  FETCH_PROJECT_REVISIONS_START,
  [FETCH_PROJECT_REVISIONS_SUCCESS, FETCH_PROJECT_REVISIONS_ERROR]
)

const fetchRevisionData = (projectId, revisionIds) => ({ type: FETCH_REVISION_DATA, projectId, revisionIds })
const fetchRevisionDataStart = () => ({ type: FETCH_REVISION_DATA_START })
const fetchRevisionDataSuccess = () => ({ type: FETCH_REVISION_DATA_SUCCESS })
const fetchRevisionDataError = (error) => ({ type: FETCH_REVISION_DATA_ERROR, error })
const startFetchRevisionData = buildAsyncAction(
  FETCH_REVISION_DATA,
  FETCH_REVISION_DATA_START,
  [FETCH_REVISION_DATA_SUCCESS, FETCH_REVISION_DATA_ERROR]
)
export {
  initRevisions,
  loadRevisionData,
  loadRevisionDataSuccess,
  updateRevisions,
  updateCurrentRevision,
  updateOldestRevision,
  updateLatestRevision,
  updateOriginalRevision,
  updateModifiedRevision,
  startPostProjectRevision,
  postProjectRevision,
  postProjectRevisionStart,
  postProjectRevisionSuccess,
  postProjectRevisionError,
  fetchProjectRevisions,
  fetchProjectRevisionsStart,
  fetchProjectRevisionsSuccess,
  fetchProjectRevisionsError,
  startFetchProjectRevisions,
  fetchRevisionData,
  fetchRevisionDataStart,
  fetchRevisionDataSuccess,
  fetchRevisionDataError,
  startFetchRevisionData,
}
